import { useStaticQuery, graphql } from "gatsby";

export default () => {
  const data = useStaticQuery(graphql`
    {
      craft {
        categories(group: "headerFeaturesCategory", siteId: "8") {
          ... on Craft_headerFeaturesCategory_Category {
            slug
            title
          }
        }
        entries(siteId: "8", section: "featurePages", status: "live") {
          typeHandle
          ... on Craft_featurePages_featurePages_Entry {
            slug
            featurePageUrlDirectory {
              slug
            }
            headerFeaturesCategory {
              slug
            }
          }
        }
        navigation: entries(section: "header", siteId: "8") {
          ... on Craft_header_header_Entry {
            getStartedTitle
            getStartedMenu {
              ... on Craft_getStartedMenu_entry_BlockType {
                id
                heading
                text
                href
              }
            }
          }
        }
      }
    }
  `);

  return data.craft;
};
